import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { forkJoin, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import swal from 'sweetalert2';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Aplicacion } from 'src/app/shared/model/fise/aplicacion.model';
import { Servidor } from 'src/app/shared/model/fise/servidor.model';
import { UsuarioFise } from 'src/app/shared/model/security/userbean.model';
import { FiseService } from '../fise.service';
import { ModalAplicacionComponent } from './modal-aplicacion/modal-aplicacion.component';
import { ModalUsuarioComponent } from './modal-usuario/modal-usuario.component';
import { SoloLetraEspacioNumeroAcentoDirective } from '../../utilerias/directives/solo-letra-espacio-numero-acento.directive';

@Component({
  selector: 'app-gestion-aplicaciones',
  standalone: true,
  templateUrl: './gestion-aplicaciones.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    ClipboardModule,
    SoloLetraEspacioNumeroAcentoDirective,
  ],
})
export class GestionAplicacionesComponent implements OnInit {
  tooltipCopiarPass = 'Copiar contraseña';
  listaServidor: Array<Servidor> = [];
  listaAp: Array<Aplicacion> = [];
  listaUs: Array<UsuarioFise> = [];
  modalRefAplicacion: MatDialogRef<any>;
  modalRefUsuario: MatDialogRef<any>;
  reqAplicacion = new ConsultaList<Aplicacion>();
  reqUsuario = new ConsultaList<UsuarioFise>();
  totalRegUsuarios = 0;
  totalRegAplicacion = 0;
  servidorSelect = new Servidor();
  aplicacionSelect = new Aplicacion();
  objAplicacion = new Aplicacion();
  servidorCtrl = new FormControl('');
  filtroAplicacion = '';
  filtroUsuario = '';
  currentAppsPage = 1;
  currentUsersPage = 1;
  appsPageSize = 5;
  usersPageSize = 5;
  readonly pageSizeOptions = [5, 10, 20];
  loadingServidores = false;
  loadingAplicaciones = false;
  loadingUsuarios = false;

  constructor(
    private modalDialog: MatDialog,
    private aplicacionService: FiseService,
    private servidorService: FiseService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.servidorCtrl.valueChanges.subscribe(() => this.filtrarServidores());
    this.consultarServidorService('');
  }

  compareServidores(serverA: Servidor | null, serverB: Servidor | null): boolean {
    return serverA?.id_Servidor === serverB?.id_Servidor;
  }

  consultarServidorService(ipServidor: string): void {
    const reqServidor = new Servidor();
    reqServidor.ip = (ipServidor ?? '').trim();
    this.loadingServidores = true;
    this.cdr.detectChanges();

    this.servidorService.consultarServidorPorIP(reqServidor).subscribe({
      next: (res) => {
        this.listaServidor = Array.isArray(res?.list) ? [...res.list] : [];
        this.loadingServidores = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.listaServidor = [];
        this.loadingServidores = false;
        this.cdr.detectChanges();
      },
    });
  }

  filtrarServidores(): void {
    const ipValor = (this.servidorCtrl.value ?? '').toString().trim();
    this.consultarServidorService(ipValor);
  }

  onServidorSelection(servidor: Servidor | null): void {
    this.servidorSelect = servidor ?? new Servidor();
    this.filtroAplicacion = '';
    this.resetAplicaciones();
    if (this.servidorSelect?.id_Servidor) {
      this.consultaAplicaciones(1);
    }
    this.cdr.detectChanges();
  }

  consultaAplicaciones(page: number): void {
    if (!this.servidorSelect?.id_Servidor) {
      this.resetAplicaciones();
      this.cdr.detectChanges();
      return;
    }

    this.currentAppsPage = Math.max(1, page);
    this.loadingAplicaciones = this.listaAp.length === 0;
    this.cdr.detectChanges();

    this.objAplicacion.id_Servidor = this.servidorSelect.id_Servidor.toString();
    this.objAplicacion.idTipo = (this.filtroAplicacion ?? '').trim();
    this.reqAplicacion.bean = this.objAplicacion;
    this.reqAplicacion.regInicial = (this.currentAppsPage - 1) * this.appsPageSize;
    this.reqAplicacion.regXPagina = this.appsPageSize;

    forkJoin({
      total: this.aplicacionService.ConsultaNumAplicaciones(this.objAplicacion),
      aplicaciones: this.servidorService.ObtenerAplicacionPorTipo(this.reqAplicacion),
    }).subscribe({
      next: ({ total, aplicaciones }) => {
        this.totalRegAplicacion = this.resolveTotalRegistros(total, aplicaciones, this.currentAppsPage, this.appsPageSize);
        this.listaAp = Array.isArray(aplicaciones?.list) ? [...aplicaciones.list] : [];

        const maxPages = this.appsTotalPages;
        if (maxPages > 0 && this.currentAppsPage > maxPages) {
          this.consultaAplicaciones(maxPages);
          return;
        }

        if (maxPages === 0) {
          this.currentAppsPage = 1;
        }

        this.loadingAplicaciones = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.listaAp = [];
        this.totalRegAplicacion = 0;
        this.currentAppsPage = 1;
        this.loadingAplicaciones = false;
        this.cdr.detectChanges();
      },
    });
  }

  onFiltroAplicacionChange(): void {
    this.currentAppsPage = 1;
    this.consultaAplicaciones(1);
  }

  onClicMostrarAppXIp(servidorOb: Servidor): void {
    this.onServidorSelection(servidorOb);
  }

  onClicMostrarModalAplicacion(aplicacionEdit: Aplicacion | null): void {
    if (!this.servidorSelect?.id_Servidor || this.modalDialog.openDialogs.length > 0) {
      return;
    }

    const aplicacion = aplicacionEdit ? aplicacionEdit : new Aplicacion();
    aplicacion.id_Servidor = this.servidorSelect.id_Servidor.toString();
    aplicacion.ipServidor = this.servidorSelect.ip;

    this.modalRefAplicacion = this.modalDialog.open(ModalAplicacionComponent, {
      disableClose: true,
      autoFocus: true,
      width: '620px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: ['custom-modalbox', 'fise-form-dialog'],
      data: aplicacion,
    });

    this.modalRefAplicacion.afterClosed().subscribe((value) => {
      if (value !== null && value !== undefined) {
        this.consultaAplicaciones(this.currentAppsPage);
      } else {
        this.cdr.detectChanges();
      }
    });
  }

  onClicBorrarApp(aplicacion: Aplicacion): void {
    swal
      .fire({
        title: 'Alerta',
        text: '¿Desea borrar esta aplicación? Los usuarios relacionados también serán eliminados.',
        buttonsStyling: false,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-info',
        },
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showConfirmButton: true,
        showCancelButton: true,
      })
      .then((value) => {
        if (!value.value) {
          return;
        }

        this.aplicacionService.EliminarApp(aplicacion.id).subscribe((response) => {
          if (!response?.pCodRetorno) {
            return;
          }

          swal.fire({
            title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
            text: response.pMensaje,
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-info',
            },
            confirmButtonText: 'Aceptar',
            icon: response.pCodRetorno === '00000' ? 'success' : 'warning',
          });

          if (response.pCodRetorno === '00000') {
            if (this.aplicacionSelect?.id === aplicacion.id) {
              this.resetUsuarios();
            }
            this.consultaAplicaciones(this.currentAppsPage);
          }
        });
      });
  }

  onClicMostrarUsuarioxApp(aplicacionOb: Aplicacion): void {
    this.aplicacionSelect = aplicacionOb;
    this.filtroUsuario = '';
    this.consultaUsuarios(1);
  }

  consultaUsuarios(page: number): void {
    if (!this.aplicacionSelect?.id) {
      this.resetUsuarios();
      this.cdr.detectChanges();
      return;
    }

    this.currentUsersPage = Math.max(1, page);
    this.loadingUsuarios = this.listaUs.length === 0;
    this.cdr.detectChanges();

    const usuarioReq = new UsuarioFise();
    usuarioReq.id_Aplicacion = this.aplicacionSelect.id;
    usuarioReq.usuario = (this.filtroUsuario ?? '').trim();
    this.reqUsuario.bean = usuarioReq;
    this.reqUsuario.regInicial = (this.currentUsersPage - 1) * this.usersPageSize;
    this.reqUsuario.regXPagina = this.usersPageSize;

    forkJoin({
      total: this.aplicacionService.contarUsuarioPorApp(usuarioReq),
      usuarios: this.servidorService.obtenerUsuarioPorAppPag(this.reqUsuario),
    }).subscribe({
      next: ({ total, usuarios }) => {
        this.totalRegUsuarios = this.resolveTotalRegistros(total, usuarios, this.currentUsersPage, this.usersPageSize);
        this.listaUs = Array.isArray(usuarios?.list) ? [...usuarios.list] : [];

        const maxPages = this.usersTotalPages;
        if (maxPages > 0 && this.currentUsersPage > maxPages) {
          this.consultaUsuarios(maxPages);
          return;
        }

        if (maxPages === 0) {
          this.currentUsersPage = 1;
        }

        this.loadingUsuarios = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.listaUs = [];
        this.totalRegUsuarios = 0;
        this.currentUsersPage = 1;
        this.loadingUsuarios = false;
        this.cdr.detectChanges();
      },
    });
  }

  onFiltroUsuarioChange(): void {
    this.consultaUsuarios(1);
  }

  OnClicMostrarModalUsuario(usuarioEdit: UsuarioFise | null): void {
    if (!this.aplicacionSelect?.id || this.modalDialog.openDialogs.length > 0) {
      return;
    }

    const usuario = usuarioEdit ? usuarioEdit : new UsuarioFise();
    usuario.id_Aplicacion = this.aplicacionSelect.id;

    this.modalRefUsuario = this.modalDialog.open(ModalUsuarioComponent, {
      disableClose: true,
      autoFocus: true,
      width: '620px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: ['custom-modalbox', 'fise-form-dialog'],
      data: usuario,
    });

    this.modalRefUsuario.afterClosed().subscribe((value) => {
      if (value !== null && value !== undefined) {
        this.consultaUsuarios(this.currentUsersPage);
      } else {
        this.cdr.detectChanges();
      }
    });
  }

  onClicBorrarUsuario(usuario: UsuarioFise): void {
    swal
      .fire({
        title: 'Alerta',
        text: '¿Desea borrar este usuario?',
        buttonsStyling: false,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-info',
        },
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showConfirmButton: true,
        showCancelButton: true,
      })
      .then((value) => {
        if (!value.value) {
          return;
        }

        this.aplicacionService.EliminarUsuario(usuario.id).subscribe((response) => {
          if (!response?.pCodRetorno) {
            return;
          }

          swal.fire({
            title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
            text: response.pMensaje,
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-info',
            },
            confirmButtonText: 'Aceptar',
            icon: response.pCodRetorno === '00000' ? 'success' : 'warning',
          });

          if (response.pCodRetorno === '00000') {
            this.consultaUsuarios(this.currentUsersPage);
          }
        });
      });
  }

  onClicCopiar(): void {
    this.tooltipCopiarPass = '¡Copiado!';
    of(1)
      .pipe(delay(1500))
      .subscribe({ complete: () => (this.tooltipCopiarPass = 'Copiar contraseña') });
  }

  onAppsPageSizeChange(value: number): void {
    this.appsPageSize = Number(value);
    this.consultaAplicaciones(1);
  }

  onUsersPageSizeChange(value: number): void {
    this.usersPageSize = Number(value);
    this.consultaUsuarios(1);
  }

  onAppsPageChange(page: number): void {
    if (page === this.currentAppsPage || page < 1 || page > this.appsTotalPages) {
      return;
    }
    this.consultaAplicaciones(page);
  }

  onUsersPageChange(page: number): void {
    if (page === this.currentUsersPage || page < 1 || page > this.usersTotalPages) {
      return;
    }
    this.consultaUsuarios(page);
  }

  firstAppsPage(): void {
    this.onAppsPageChange(1);
  }

  previousAppsPage(): void {
    this.onAppsPageChange(this.currentAppsPage - 1);
  }

  nextAppsPage(): void {
    this.onAppsPageChange(this.currentAppsPage + 1);
  }

  lastAppsPage(): void {
    this.onAppsPageChange(this.appsTotalPages);
  }

  firstUsersPage(): void {
    this.onUsersPageChange(1);
  }

  previousUsersPage(): void {
    this.onUsersPageChange(this.currentUsersPage - 1);
  }

  nextUsersPage(): void {
    this.onUsersPageChange(this.currentUsersPage + 1);
  }

  lastUsersPage(): void {
    this.onUsersPageChange(this.usersTotalPages);
  }

  get appsTotalPages(): number {
    return this.totalRegAplicacion > 0 ? Math.ceil(this.totalRegAplicacion / this.appsPageSize) : 0;
  }

  get usersTotalPages(): number {
    return this.totalRegUsuarios > 0 ? Math.ceil(this.totalRegUsuarios / this.usersPageSize) : 0;
  }

  get showAppsPagination(): boolean {
    return this.totalRegAplicacion > 0;
  }

  get showUsersPagination(): boolean {
    return this.totalRegUsuarios > 0;
  }

  get appsRangeEnd(): number {
    return Math.min(this.currentAppsPage * this.appsPageSize, this.totalRegAplicacion);
  }

  get usersRangeEnd(): number {
    return Math.min(this.currentUsersPage * this.usersPageSize, this.totalRegUsuarios);
  }

  getPaginationItems(totalPages: number, currentPage: number): Array<number | string> {
    if (totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([1, totalPages, currentPage - 1, currentPage, currentPage + 1]);
    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  getAppsPaginationItems(): Array<number | string> {
    return this.getPaginationItems(this.appsTotalPages, this.currentAppsPage);
  }

  getUsersPaginationItems(): Array<number | string> {
    return this.getPaginationItems(this.usersTotalPages, this.currentUsersPage);
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === 'number';
  }

  getAplicacionEmptyTitle(): string {
    return this.servidorSelect?.id_Servidor ? 'No se encontraron aplicaciones' : 'Seleccione un servidor';
  }

  getAplicacionEmptyMessage(): string {
    return this.servidorSelect?.id_Servidor
      ? 'Ajuste el filtro o agregue una nueva aplicación para este servidor.'
      : 'Elija un servidor en la parte superior para consultar y administrar sus aplicaciones.';
  }

  getUsuariosEmptyTitle(): string {
    return this.aplicacionSelect?.id ? 'No se encontraron usuarios' : 'Seleccione una aplicación';
  }

  getUsuariosEmptyMessage(): string {
    return this.aplicacionSelect?.id
      ? 'Ajuste el filtro o agregue un nuevo usuario para esta aplicación.'
      : 'Seleccione una aplicación para visualizar y administrar sus usuarios asociados.';
  }

  private resetAplicaciones(): void {
    this.listaAp = [];
    this.totalRegAplicacion = 0;
    this.currentAppsPage = 1;
    this.loadingAplicaciones = false;
    this.resetUsuarios();
  }

  private resetUsuarios(): void {
    this.aplicacionSelect = new Aplicacion();
    this.listaUs = [];
    this.totalRegUsuarios = 0;
    this.currentUsersPage = 1;
    this.loadingUsuarios = false;
  }

  private resolveTotalRegistros(
    total: unknown,
    response: ConsultaList<Aplicacion> | ConsultaList<UsuarioFise>,
    currentPage: number,
    pageSize: number
  ): number {
    const totalResponse = total as Record<string, unknown> | null;
    const responseList = response as (ConsultaList<Aplicacion> | ConsultaList<UsuarioFise>) & Record<string, unknown>;
    const candidates = [
      totalResponse?.pTotalItems,
      totalResponse?.totalItems,
      totalResponse?.totalRegistros,
      responseList?.pTotalItems,
      responseList?.totalItems,
      responseList?.totalRegistros,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    const currentItems = Array.isArray(response?.list) ? response.list.length : 0;
    if (currentItems === 0) {
      return 0;
    }

    return (currentPage - 1) * pageSize + currentItems;
  }
}
